import { render, staticRenderFns } from "./income-history-page.vue?vue&type=template&id=79da6878&scoped=true"
import script from "./income-history-page.vue?vue&type=script&lang=ts"
export * from "./income-history-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da6878",
  null
  
)

export default component.exports